<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="values"
        :hide-default-header="empty"
        :height="values.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer
        dense
        :show-select="bulkMode"
        v-model="selected"
        item-key="uid"
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar
          v-if="toolbar"
          flat
          dense
        >
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>

        <div v-if="showBulk && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
          <v-checkbox
            v-model="bulkMode"
            hide-details
            :disabled="!items.length"
            class="mt-0 pt-0"
          />

          <v-btn
            x-small
            class="ma-2 white--text"
            color="red"
            :disabled="!bulkMode || !deletableCountLocal"
            @click="bulkRemove"
          >
            Bulk Delete
            <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.actions="{item, index}">
        <v-icon @click="row_update(item, index)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item, index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item, index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item, index)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>

    <r-reward-package-dropdown-dialog ref="dialog"/>
  </div>
</template>


<script>

import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RRewardPackageDropdownDialog from "@/modules/redactor/views/reward-pack/r-reward-package-dropdown-dialog.vue";

export default {
  name: "r-reward-package-table",
  components: {RRewardPackageDropdownDialog},
  props: {
    title: VueTypes.string.def("Packages"),
    items: VueTypes.arrayOf(VueTypes.string),
    toolbar: VueTypes.bool.def(true),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'name'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    values() {
      const ids = Array.isArray(this.items) ? this.items.filter(Boolean) : [];
      return ids
        .map(id => RedactorUtils.getRewardPackage(id))
        .filter(Boolean);
    },

    empty() {
      return this.values.length === 0;
    },

    deletableCountLocal() {
      return this.selected.length;
    },
  },

  methods: {
    appendIds(ids) {
      if (!Array.isArray(ids) || ids.length === 0) return;

      const src = this.items || [];
      src.push(...ids);
    },

    row_copy(item) {
      this.$refs.dialog.show(ViewRules.COPY, item)
        .then(this.appendIds)
        .catch(() => {});
    },

    row_create() {
      this.$refs.dialog.show(ViewRules.CREATE)
        .then(this.appendIds)
        .catch(() => {});
    },
    row_update(item, index) {
      this.$refs.dialog.show(ViewRules.UPDATE)
          .then((data) => {
            if (Array.isArray(data)) {
              this.items.splice(index, 1, data[0]);
              return;
            }
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item, index) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        if(!item && this.items[index]){
          this.items.splice(index, 1);
        }
        else if (this.items[index] === item.uid) {
          this.items.splice(index, 1);
        }
      });
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          const toRemove = new Set(this.selected.map(pkg => pkg.uid));

          for (let i = this.items.length - 1; i >= 0; i--) {
            if (toRemove.has(this.items[i])) {
              this.items.splice(i, 1);
            }
          }

          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    },

    row_moveup(item, index) {
      if (this.items[index] === item.uid && index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item, index) {
      if (this.items[index] === item.uid && index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  },

  watch: {
    items(newItems) {
      const valid = new Set(newItems || []);
      this.selected = this.selected.filter(pkg => valid.has(pkg.uid));
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
}
</script>